import { EnumCommentStatus } from "src/api/client/comment-v2.api.types";
import { TComment } from "src/components/common/comments-area/comment/comment.types";

type TMarkAsDeleted = {
    comments: TComment[];
    commentIdToDelete: string;
};
export const markAsDeleted = ({ comments, commentIdToDelete }: TMarkAsDeleted): TComment[] => {
    return comments.map(comment => {
        if (comment.commentId === commentIdToDelete) {
            return { ...comment, status: EnumCommentStatus.Deleted };
        }
        return comment;
    });
};
